export default __webpack_public_path__ + "static/locate_transparent-527084345a2ecd98db962bf3cc669a5b.png";